import React from 'react';

import { Logs, Log, SidePage, LogText, LogComment } from '@gogame/components';

import { useActionsLog } from 'scenes/Gallery/GalleryPage/Creatives/data';

const ActionsLogTab = ({ creativeId }) => {
  const { data, isLoading, isRefetching } = useActionsLog({
    id: creativeId,
  });
  return (
    <SidePage.NewBody
      dense={true}
      wrapper={true}
      loading={isLoading}
      fetching={isRefetching}
    >
      <SidePage.NewContent withSidebar={false}>
        <Logs
          empty={!data?.length}
          noResultsProps={{ inited: !isLoading && !!data }}
        >
          {data?.map((log) => {
            return (
              <Log color={'info'}>
                <LogText
                  date={log.createdDate}
                  action={log.actionType}
                  user={log.userName}
                >
                  {log.message && <LogComment>{log.message}</LogComment>}
                </LogText>
              </Log>
            );
          })}
        </Logs>
      </SidePage.NewContent>
    </SidePage.NewBody>
  );
};

export default ActionsLogTab;
